/**
 * Broker connection API client — desk + agent routing.
 * Includes Robinhood Agentic Trading MCP status/connect.
 */

import { BaseApiClient } from './base-client';
import type { ApiResponse } from './config';

export type BrokerConnectionType =
  | 'alpaca'
  | 'ccxt'
  | 'robinhood_agentic'
  | 'interactive_brokers'
  | 'custom'
  | string;

export interface BrokerConnectionInfo {
  id: string;
  name: string;
  type: BrokerConnectionType;
  connected: boolean;
  paper_trading?: boolean;
  agent_ready?: boolean;
  mcp_url?: string;
  docs?: string;
  assets?: string[];
  account_mode?: string;
  description?: string;
  connect_mode?: string;
  error?: string;
}

export interface BrokersListResponse {
  brokers: BrokerConnectionInfo[];
  default?: string;
  updated_at?: string;
}

export interface RobinhoodAgenticStatus {
  broker: string;
  connected: boolean;
  mcp_url: string;
  agent_ready: boolean;
  balance?: {
    equity?: number;
    buying_power?: number;
    total_balance?: number;
    currency?: string;
  };
  docs?: string;
  tools?: string[];
}

export class BrokerApiClient extends BaseApiClient {
  async listBrokers(): Promise<ApiResponse<BrokersListResponse>> {
    return this.get('/api/v1/brokers');
  }

  /**
   * @deprecated CU 86bbcdu23 — use appApi.connections for RH status.
   * Kept for ops scripts / dual-run probes only.
   */
  async getRobinhoodAgenticStatus(): Promise<ApiResponse<RobinhoodAgenticStatus>> {
    return this.get('/api/v1/brokers/robinhood-agentic/status');
  }

  /**
   * @removed QTP CU 86bbcdwcd — route unregistered.
   * Use appApi.connections.create + putCredentials({access_token}) + validate.
   */
  async connectRobinhoodAgentic(_accessToken: string): Promise<never> {
    throw new Error(
      'POST /brokers/robinhood-agentic/connect removed. Use appApi.connections credentials lifecycle.'
    );
  }

  /**
   * @removed QTP CU 86bbcdwcd — route unregistered.
   * Use appApi.connections.revoke(connection_id).
   */
  async disconnectRobinhoodAgentic(): Promise<never> {
    throw new Error(
      'POST /brokers/robinhood-agentic/disconnect removed. Use appApi.connections.revoke.'
    );
  }
}
